import React, { useState } from "react";
import ApplicationForm from "./latestApplication";
import WarningModal from "../../components/WarningModal";

export default function ApplicationPage() {
  const [showModal, setShowModal] = useState(true);

  return (
    <div className="bg-gray-50 min-h-screen px-3 sm:px-4 lg:px-6 py-8">
      <div className="w-full max-w-6xl mx-auto text-center">
        <ApplicationForm />
      </div>

      <WarningModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
}
